import { createFileRoute, Outlet } from "@tanstack/react-router";
import { applyAuthGuard } from "@/routes/-auth-guard";
import InspectionsLayout from "@/app/inspections/layout";
import {
  readLastKnownAccessToken,
  recoverAuthTokens,
} from "@/lib/inspections/auth-token-helper";

export const Route = createFileRoute("/inspections")({
  // Token recovery runs before the guard decides anything: an installed app
  // whose cookies are gone still has its session in the IndexedDB backup.
  beforeLoad: async ({ location }) => {
    await recoverAuthTokens();
    applyAuthGuard(
      location.pathname,
      new URLSearchParams(location.searchStr),
      undefined,
      await readLastKnownAccessToken(),
    );
  },
  component: () => (
    <InspectionsLayout>
      <Outlet />
    </InspectionsLayout>
  ),
});
